export const AUTH_LOGIN_USER_REQUEST = 'AUTH_LOGIN_USER_REQUEST';
export const AUTH_LOGIN_USER_FAILURE = 'AUTH_LOGIN_USER_FAILURE';
export const AUTH_LOGIN_USER_SUCCESS = 'AUTH_LOGIN_USER_SUCCESS';
export const AUTH_LOGOUT_USER = 'AUTH_LOGOUT_USER';
export const AUTH_SOCIAL_LOGIN_REQUEST = 'AUTH_SOCIAL_LOGIN_REQUEST';
export const AUTH_SOCIAL_LOGIN_REQUEST_AND_SET_PROVIDER =
  'AUTH_SOCIAL_LOGIN_REQUEST_AND_SET_PROVIDER';
export const AUTH_OPEN_SOCIAL_WINDOW = 'AUTH_OPEN_SOCIAL_WINDOW';
export const AUTH_HANDLE_CONFIRM_REDIRECT = 'AUTH_HANDLE_CONFIRM_REDIRECT';
export const AUTH_POST_SIGNUP_REQUEST = 'AUTH_POST_SIGNUP_REQUEST';
export const AUTH_POST_SIGNUP_FAILURE = 'AUTH_POST_SIGNUP_FAILURE';
export const AUTH_FORGOT_PASSWORD_REQUEST = 'AUTH_FORGOT_PASSWORD_REQUEST';
export const AUTH_FORGOT_PASSWORD_FAILURE = 'AUTH_FORGOT_PASSWORD_FAILURE';
export const AUTH_FORGOT_PASSWORD_SUCCESS = 'AUTH_FORGOT_PASSWORD_SUCCESS';
export const AUTH_PASSWORD_RESET_REQUEST = 'AUTH_PASSWORD_RESET_REQUEST';
export const AUTH_PASSWORD_RESET_FAILURE = 'AUTH_PASSWORD_RESET_FAILURE';
export const AUTH_PASSWORD_RESET_SUCCESS = 'AUTH_PASSWORD_RESET_SUCCESS';
export const AUTH_SET_RESET_TOKEN = 'AUTH_SET_RESET_TOKEN';
export const AUTH_CLEAR_RESET_TOKEN = 'AUTH_CLEAR_RESET_TOKEN';
export const AUTH_ASSOCIATE_USER_REQUEST = 'AUTH_ASSOCIATE_USER_REQUEST';
export const AUTH_ASSOCIATE_USER_FAILURE = 'AUTH_ASSOCIATE_USER_FAILURE';
export const AUTH_ASSOCIATE_USER_SUCCESS = 'AUTH_ASSOCIATE_USER_SUCCESS';
export const AUTH_DISQUS_RESET = 'AUTH_DISQUS_RESET';
export const AUTH_DISQUS_SET = 'AUTH_DISQUS_SET';
export const AUTH_USER_INFO_PANELS = 'AUTH_USER_INFO_PANELS';
export const AUTH_SET_ACTION = 'AUTH_SET_ACTION';
export const AUTH_SET_CAMERAS_API_TOKEN = 'AUTH_SET_CAMERAS_API_TOKEN';
export const AUTH_SET_SNAPSHOT_RATINGS = 'AUTH_SET_SNAPSHOT_RATINGS';
export const AUTH_BROADCAST_REQUEST = 'AUTH_BROADCAST_REQUEST';
export const AUTH_BROADCAST_FAILURE = 'AUTH_BROADCAST_FAILURE';
export const AUTH_BROADCAST_SUCCESS = 'AUTH_BROADCAST_SUCCESS';
export const AUTH_TEMPLATE_REQUEST = 'AUTH_BROADCAST_REQUEST';
export const AUTH_TEMPLATE_FAILURE = 'AUTH_BROADCAST_FAILURE';
export const AUTH_TEMPLATE_SUCCESS = 'AUTH_BROADCAST_SUCCESS';
export const AUTH_PLAYER_ALERT_SUCCESS = 'AUTH_PLAYER_ALERT_SUCCESS';
export const AUTH_PLAYER_ALERT_FAILURE = 'AUTH_PLAYER_ALERT_FAILURE';
export const AUTH_PLAYER_ALERT_REQUEST = 'AUTH_PLAYER_ALERT_REQUEST';

export const AUTH_DELETE_USER_REQUEST = 'AUTH_DELETE_USER_REQUEST';
export const AUTH_DELETE_USER_FAILURE = 'AUTH_DELETE_USER_FAILURE';
export const AUTH_DELETE_USER_SUCCESS = 'AUTH_DELETE_USER_SUCCESS';

export const SET_GQL_TOKEN = 'SET_GQL_TOKEN';
export const SET_COMMENT_USER = 'SET_COMMENT_USER';


export const DATA_FETCH_PROTECTED_DATA_REQUEST =
  'DATA_FETCH_PROTECTED_DATA_REQUEST';
export const DATA_RECEIVE_PROTECTED_DATA = 'DATA_RECEIVE_PROTECTED_DATA';

export const CAM_GROUP_REQUEST = 'CAM_GROUP_REQUEST';
export const CAM_GROUP_FAILURE = 'CAM_GROUP_FAILURE';
export const CAM_GROUP_SUCCESS = 'CAM_GROUP_SUCCESS';
export const SET_CAM_GROUP_INFO = 'SET_CAM_GROUP_INFO';

export const FEED_REQUEST = 'FEED_REQUEST';
export const FEED_SUCCESS = 'FEED_SUCCESS';
export const FEED_FAILURE = 'FEED_FAILURE';

export const CHANNEL_FEED_REQUEST = 'CHANNEL_FEED_REQUEST';
export const CHANNEL_FEED_FAILURE = 'CHANNEL_FEED_FAILURE';
export const CHANNEL_FEED_SUCCESS = 'CHANNEL_FEED_SUCCESS';

export const GFY_FEED_REQUEST = 'GFY_FEED_REQUEST';
export const GFY_FEED_FAILURE = 'GFY_FEED_FAILURE';
export const GFY_FEED_SUCCESS = 'GFY_FEED_SUCCESS';

export const GET_GFY = 'GET_GFY';
export const GET_GFY_SUCCESS = 'GET_GFY_SUCCESS';

export const INSTAGRAM_FEED_REQUEST = 'INSTAGRAM_FEED_REQUEST';
export const INSTAGRAM_FEED_FAILURE = 'INSTAGRAM_FEED_FAILURE';
export const INSTAGRAM_FEED_SUCCESS = 'INSTAGRAM_FEED_SUCCESS';

export const CAMERA_REQUEST = 'CAMERA_REQUEST';
export const CAMERA_FAILURE = 'CAMERA_FAILURE';
export const CAMERA_SUCCESS = 'CAMERA_SUCCESS';

export const CURRENT_ITEM_REQUEST = 'CURRENT_ITEM_REQUEST';
export const CURRENT_ITEM_FAILURE = 'CURRENT_ITEM_FAILURE';
export const CURRENT_ITEM_SUCCESS = 'CURRENT_ITEM_SUCCESS';
export const SET_CURRENT_ITEM = 'SET_CURRENT_ITEM';

export const BLOG_POSTS_REQUEST = 'BLOG_POSTS_REQUEST';
export const BLOG_POSTS_FAILURE = 'BLOG_POSTS_FAILURE';
export const BLOG_POSTS_SUCCESS = 'BLOG_POSTS_SUCCESS';
export const DATA_FETCH_BLOG_POSTS_REQUEST = 'DATA_FETCH_BLOG_POSTS_REQUEST';
export const DATA_RECEIVE_BLOG_POSTS_DATA = 'DATA_RECEIVE_BLOG_POSTS_DATA';

export const RELATED_SNAPSHOTS_FEED_REQUEST = 'RELATED_SNAPSHOTS_FEED_REQUEST';
export const RELATED_SNAPSHOTS_FEED_FAILURE = 'RELATED_SNAPSHOTS_FEED_FAILURE';
export const RELATED_SNAPSHOTS_FEED_SUCCESS = 'RELATED_SNAPSHOTS_FEED_SUCCESS';
export const RELATED_SNAPSHOTS_FEED_RESET = 'RELATED_SNAPSHOTS_FEED_RESET';
export const RELATED_SNAPSHOTS_MOUNTED = 'RELATED_SNAPSHOTS_MOUNTED';

export const WEATHER_REQUEST = 'WEATHER_REQUEST';
export const WEATHER_FAILURE = 'WEATHER_FAILURE';
export const WEATHER_SUCCESS = 'WEATHER_SUCCESS';

export const SET_CAM_GROUP_POSITION = 'SET_CAM_GROUP_POSITION';
export const SET_CHANNEL_POSITION = 'SET_CHANNEL_POSITION';
export const SET_INITIAL_ACTIVE_CHANNEL = 'SET_INITIAL_ACTIVE_CHANNEL';

export const SET_CURRENT_ITEM_BY_SLUG = 'SET_CURRENT_ITEM_BY_SLUG';
export const SET_CURRENT_ITEM_BY_FEED = 'SET_CURRENT_ITEM_BY_FEED';
export const SET_CURRENT_ITEM_BY_USERNAME = 'SET_CURRENT_ITEM_BY_USERNAME';
export const SET_SELECTED_ITEM = 'SET_SELECTED_ITEM';

export const SNAPSHOTS_FEED_REQUEST = 'SNAPSHOTS_FEED_REQUEST';
export const SNAPSHOTS_FEED_FAILURE = 'SNAPSHOTS_FEED_FAILURE';
export const SNAPSHOTS_FEED_SUCCESS = 'SNAPSHOTS_FEED_SUCCESS';
export const SNAPSHOTS_FEED_RESET = 'SNAPSHOTS_FEED_RESET';

export const CONFIG_SET_BACKGROUND_IMAGE = 'CONFIG_SET_BACKGROUND_IMAGE';
export const CONFIG_SET_BACKGROUND_RESET = 'CONFIG_SET_BACKGROUND_RESET';
export const CONFIG_SET_COUNTRIES = 'CONFIG_SET_COUNTRIES';
export const CONFIG_SET_CURRENT_SECTION = 'CONFIG_SET_CURRENT_SECTION';
export const CONFIG_SET_DEFAULT_ITEM = 'CONFIG_SET_DEFAULT_ITEM';
export const CONFIG_SET_INITIAL_LOAD = 'CONFIG_SET_INITIAL_LOAD';
export const CONFIG_SET_INITIAL_LOAD_ERROR = 'CONFIG_SET_INITIAL_LOAD_ERROR';
export const CONFIG_SET_PREVIOUS_PATH = 'CONFIG_SET_PREVIOUS_PATH';
export const CONFIG_SET_SNAPSHOTS_ENABLED = 'CONFIG_SET_SNAPSHOTS_ENABLED';
export const CONFIG_SET_WEBSITE_BACKGROUNDS = 'CONFIG_SET_WEBSITE_BACKGROUNDS';
export const CONFIG_SET_LOGO = 'CONFIG_SET_LOGO';
export const CONFIG_SET_SERVER_ERROR = 'CONFIG_SET_SERVER_ERROR';
export const SET_STATIC_PAGE = 'SET_STATIC_PAGE';
export const STATIC_PAGE_LOADING = 'STATIC_PAGE_LOADING';

export const ADD_USER_FAVORITE_REQUEST = 'ADD_USER_FAVORITE_REQUEST';
export const ADD_USER_FAVORITE_SUCCESS = 'ADD_USER_FAVORITE_SUCCESS';
export const ADD_USER_FAVORITE_FAILURE = 'ADD_USER_FAVORITE_FAILURE';
export const REMOVE_USER_FAVORITE_REQUEST = 'REMOVE_USER_FAVORITE_REQUEST';
export const REMOVE_USER_FAVORITE_SUCCESS = 'REMOVE_USER_FAVORITE_SUCCESS';
export const REMOVE_USER_FAVORITE_FAILURE = 'REMOVE_USER_FAVORITE_FAILURE';
export const FETCH_USER_FAVORITE_REQUEST = 'FETCH_USER_FAVORITE_REQUEST';
export const FETCH_USER_FAVORITE_SUCCESS = 'FETCH_USER_FAVORITE_SUCCESS';
export const FETCH_USER_FAVORITE_FAILURE = 'FETCH_USER_FAVORITE_FAILURE';
export const RESET_USER_FAVORITES = 'RESET_USER_FAVORITES';
export const TOGGLE_SNAPSHOT_FAVORITE = 'TOGGLE_SNAPSHOT_FAVORITE';
export const TOGGLE_SNAPSHOT_FAVORITE_SUCCESS = 'TOGGLE_SNAPSHOT_FAVORITE_SUCCESS';
export const TOGGLE_SNAPSHOT_FAVORITE_FAILURE = 'TOGGLE_SNAPSHOT_FAVORITE_FAILURE';
export const DELETE_USER_SNAPSHOT_REQUEST = 'DELETE_USER_SNAPSHOT_REQUEST';
export const DELETE_USER_SNAPSHOT_SUCCESS = 'DELETE_USER_SNAPSHOT_SUCCESS';
export const DELETE_USER_SNAPSHOT_FAILURE = 'DELETE_USER_SNAPSHOT_FAILURE';

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const REMOVE_ERROR_MESSAGE = 'REMOVE_ERROR_MESSAGE';

export const SET_ALERTS = 'SET_ALERTS';
export const SET_ALERT_MESSAGE = 'SET_ALERT_MESSAGE';
export const UPDATING_ALERTS = 'UPDATING_ALERTS';
export const REMOVE_ALERT_MESSAGE = 'REMOVE_ALERT_MESSAGE';
export const HOMEPAGE_ALERT_SUCCESS = 'HOMEPAGE_ALERT_SUCCESS';
export const HOMEPAGE_ALERT_DISMISS = 'HOMEPAGE_ALERT_DISMISS';

export const UNSET_JANRAIN = 'UNSET_JANRAIN';

export const CURRENT_USER_REQUEST = 'CURRENT_USER_REQUEST';
export const CURRENT_USER_SUCCESS = 'CURRENT_USER_SUCCESS';
export const CURRENT_USER_FAILURE = 'CURRENT_USER_FAILURE';
export const CURRENT_USER_SAVE_REQUEST = 'USER_PROFILE_SAVE_REQUEST';
export const CURRENT_USER_SAVE_SUCCESS = 'USER_PROFILE_SAVE_SUCCESS';
export const CURRENT_USER_SAVE_FAILURE = 'USER_PROFILE_SAVE_FAILURE';
export const CURRENT_USER_UPDATE_AVATAR = 'CURRENT_USER_UPDATE_AVATAR';
export const CURRENT_USER_RESET = 'CURRENT_USER_RESET';

export const CURRENT_USER_NEW_NOTIFICATIONS = 'CURRENT_USER_NEW_NOTIFICATIONS';
export const CURRENT_USER_CLEAR_NOTIFICATIONS = 'CURRENT_USER_CLEAR_NOTIFICATIONS';

export const MEMBER_PROFILE_REQUEST = 'MEMBER_PROFILE_REQUEST';
export const MEMBER_PROFILE_SUCCESS = 'MEMBER_PROFILE_SUCCESS';
export const MEMBER_PROFILE_FAILURE = 'MEMBER_PROFILE_FAILURE';
export const MEMBER_PROFILE_FAVORITES_UPDATE =
  'MEMBER_PROFILE_FAVORITES_UPDATE';

export const METADATA_REQUEST = 'METADATA_REQUEST';
export const METADATA_SUCCESS = 'METADATA_SUCCESS';
export const METADATA_FAILURE = 'METADATA_FAILURE';

export const GENERATE_SNAPSHOT_TIMELINE = 'GENERATE_SNAPSHOT_TIMELINE';
export const ADD_SNAPSHOT_TIME = 'ADD_SNAPSHOT_TIME';
export const SET_SNAPSHOT_TIMELINE_INDEX = 'SET_SNAPSHOT_TIMELINE_INDEX';
export const SET_INITIAL_TIMESTAMP = 'SET_INITIAL_TIMESTAMP';
export const UPDATE_SNAPSHOT_TIMELINE_COUNT = 'UPDATE_SNAPSHOT_TIMELINE_COUNT';
export const SNAPSHOT_TIMESTAMP_REMOVED = 'SNAPSHOT_TIMESTAMP_REMOVED';

export const SET_COMMENTS_WIDTH_HALF = 'SET_COMMENTS_WIDTH_HALF';
export const SET_COMMENTS_WIDTH_FULL = 'SET_COMMENTS_WIDTH_FULL';
export const TOGGLE_COMMENTS_WIDTH = 'TOGGLE_COMMENTS_WIDTH';
export const TOGGLE_INFO_PANELS = 'TOGGLE_INFO_PANELS';
export const SET_NOTIFICATION_EXCEPTIONS = 'SET_NOTIFICATION_EXCEPTIONS';
export const SET_BACKGROUND_PREFERENCE = 'SET_BACKGROUND_PREFERENCE';

export const SET_RELATED_SNAPSHOTS_SHOW = 'SET_RELATED_SNAPSHOTS_SHOW';
export const SET_RELATED_SNAPSHOTS_HIDE = 'SET_RELATED_SNAPSHOTS_HIDE';
export const TOGGLE_RELATED_SNAPSHOTS = 'TOGGLE_RELATED_SNAPSHOTS';
export const SHOW_RELATED_SNAPSHOTS = 'SHOW_RELATED_SNAPSHOTS';

export const DISABLE_REGISTRATION_PROMPT = 'DISABLE_REGISTRATION_PROMPT';
export const LIVECAM_CLICK_TRACKER = 'LIVECAM_CLICK_TRACKER';
export const SET_IS_LIVE_STATUS = 'SET_IS_LIVE_STATUS';

export const CHANGE_VIEW_MODE = 'CHANGE_VIEW_MODE';
export const CALENDAR_EVENT_REQUEST = 'CALENDAR_EVENT_REQUEST';
export const CALENDAR_EVENT_SUCCESS = 'CALENDAR_EVENT_SUCCESS';
export const CALENDAR_EVENT_FAILURE = 'CALENDAR_EVENT_FAILURE';
